import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { ImLocation2 } from "react-icons/im";
import { SocialIcon } from "react-social-icons";
import "./App.css";
import dataJson from "./data.json";
import ProjectCard from "./components/ProjectCard";
import Tile from "./components/Tile";

function App() {
  const [lastUpdatedDate, setlastUpdatedDate] = useState("15-03-2023");
  let lastUpdatedDateText = useMemo(
    () => moment(lastUpdatedDate, "DD-MM-YYYY").fromNow(),
    [lastUpdatedDate]
  );
  const [allTags, setAllTags] = useState(true);
  const [email, setemail] = useState(0);
  const [dataFetched, setdataFetched] = useState(false);
  const [data, setdata] = useState(dataJson);
  const [displayCards, setDisplayCards] = useState(dataJson.cards);
  const [tags, settags] = useState([]);
  const fetchData = async () => {
    try {
      let response = await fetch(
        "https://sathishkumare-portfolio.s3.ap-south-1.amazonaws.com/data.json"
      );
      let json = await response.json();
      return { success: true, data: json };
    } catch (error) {
      console.log(error);
      return { success: false };
    }
  };
  // init data
  useEffect(() => {
    (async () => {
      if (!dataFetched) {
        let res = await fetchData();
        if (res.success) {
          setdata(res.data);
        } else {
          return;
        }
        setdataFetched(true);
        setlastUpdatedDate(res.data.lastUpdatedDate);
        const tagsList = [];
        data.cards.forEach((card) => {
          card.tags.forEach((tag) => {
            tagsList.push(tag.name);
          });
        });
        const uniqueTags = [...new Set(tagsList)].map((tag) => ({
          name: tag,
          active: true,
        }));
        settags(uniqueTags);
      }
    })();
  }, []);

  const copyEmail = () => {
    navigator.clipboard.writeText("esk9967@gmail.com");
    setemail(1);
    setTimeout(() => {
      setemail(0);
    }, 2000);
  };
  const toggleTag = (name) => {
    let truePresent = false;
    let falsePresent = false;
    let newTags = tags.map((tag) => {
      if (tag.name == name) {
        tag.active = !tag.active;
      }
      if (!truePresent || !falsePresent) {
        if (tag.active) {
          truePresent = true;
        }else{
          falsePresent = true;
        }
      }
      return tag;
    });
    if (!truePresent) {
      setAllTags(false);
    }else{
      setAllTags(true);
    }
    settags(newTags);
  };
  const toggleAllTags = () => {
    let newTags = tags.map((tag) => {
      tag.active = !allTags;
      return tag;
    });
    settags(newTags);
    setAllTags(!allTags);
  };
  useEffect(() => {
    let activeTags = tags.filter((tag) => tag.active).map((tag) => tag.name);
    let displayCardsTemp = [];
    data.cards.forEach((card) => {
      for (const tag of card.tags) {
        if (activeTags.includes(tag.name)) {
          displayCardsTemp.push(card);
          break;
        }
      }
      return false;
    });
    setDisplayCards(displayCardsTemp);
  }, [tags, data]);

  let cards = displayCards.map((card) => (
    <ProjectCard {...card} key={card.key} />
  ));

  return (
    <div className="bg-gray-900 text-gray-200 w-screen h-full">
      <div className="navbar">
        <a href="#contact" className="nav-item">
          Contact
        </a>
        <a href="#for-recruiters" className="nav-item">
          Note For Recruiters
        </a>
        <a href="#worked-on" className="nav-item">
          Worked On
        </a>
        <a href="#basic-info" className="nav-item">
          Basic Info
        </a>
        <a href="#" className="nav-item">
          Home
        </a>
      </div>
      <div className="mobile-navbar">
        <a href="#" className="mobile-nav-item">
          Home
        </a>
        <a href="#basic-info" className="mobile-nav-item">
          Basic Info
        </a>
        <a href="#worked-on" className="mobile-nav-item">
          Worked On
        </a>
        <a href="#for-recruiters" className="mobile-nav-item">
          Note For Recruiters
        </a>
        <a href="#contact" className="mobile-nav-item">
          Contact
        </a>
      </div>
      <div className="container px-2 mx-auto w-full">
        <h1 className="flex h-screen">
          <div className="m-auto">
            <div className="sm:text-6xl font-bold text-5xl align-middle text-center max-sm:leading-[5rem]	">
              Welcome to Sathish&apos;s{" "}
              <div className="group inline hover:cursor-pointer">
                <span className="underline">dynamic Resume</span>!
                <div className="absolute border-4 rounded-2xl border-gray-800 m-2 transition-all duration-100 scale-0 origin-left group-hover:scale-100">
                  <div className="text-xl content-right align-middle m-2 right-0">
                    This is a frequently updated resume &#40; last updated{" "}
                    <span className="underline">{lastUpdatedDateText}</span>{" "}
                    &#41;
                  </div>
                </div>
              </div>
            </div>
          </div>
        </h1>
        <div className="relative w-full">
          <a href="#basic-info">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="chevron-down"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 8.25l-7.5 7.5-7.5-7.5"
              />
            </svg>
          </a>
        </div>
      </div>
      <div id="basic-info" className="container px-2 pt-20 mx-auto">
        <h1 className="text-2xl font-bold">Basic Info</h1>
        <div className="text-2xl mt-3">
          <div className="info-div">
            <div>
              <h2 className="font-bold inline">Name : </h2>
              <span>Sathish Kumar E</span>
            </div>
            <div>
              <h2 className="font-bold">Education : </h2>
              <span>Bachelor of Tech</span>
              <br />
              <span>Computer Science and Engineering</span>
              <br />
              <span>SASTRA UNIVERSITY, Thanjavur</span>
              <br />
              <span>2017-2021</span>
            </div>
            <div>
              <h2 className="font-bold">Experience : </h2>
              <h3 className="pb-3">
                <span className="text-lime-200">
                  Intern @ <span className="font-semibold">Shopster</span>
                </span>
                <br />
                <ImLocation2 className="inline" /> Remote Feb 2020- Aug 2020
              </h3>
              <div>
                Worked on developing Generic ecommerce solutions like offer
                coupons, combo products, Google Analytics Integration, Dynamic
                SEO based on products....
              </div>
              <h3 className="mt-5 pb-3">
                <span className="text-lime-200">
                  Digital Specialist Engineer @{" "}
                  <span className="font-semibold">Infosys</span>
                </span>
                <br />
                <ImLocation2 className="inline" /> Chennai, India Sep 2020 -
                Current
              </h3>
              <div>
                Worked on mordenising Java Applet UI to mordern WebApp using
                React and mordenising Mainframe backend to Springboot for a
                logistics application.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="worked-on" className="container px-2 pt-20 mx-auto">
        <h1 className="text-2xl font-bold">Worked On</h1>
        <div className="mt-5 flex flex-wrap">
          <div className="tile bg-gray-700" onClick={() => toggleAllTags()}>
            <div>{allTags ? "Hide" : "Show"} All</div>
          </div>
          {tags.map((tag) => (
            <Tile key={tag.name} {...tag} toggleTag={toggleTag} />
          ))}
        </div>

        <div className="flex flex-wrap flex-row mt-4 justify-evenly gap-2">
          {cards}
        </div>
      </div>
      <div id="for-recruiters" className="container px-2 pt-20 mx-auto">
        <h1 className="text-2xl font-bold mb-4">Note For Recruiters</h1>
        <div className="flex items-center justify-center min-h-full">
          <h1 className="m-auto text-lg whitespace-pre-line">
            {data.note.map((para, index) => (
              <p key={index}>{para}</p>
            ))}
          </h1>
        </div>
      </div>
      <div id="contact" className="container px-2 pt-20 mx-auto">
        <h1 className="text-2xl font-bold">Contact</h1>
        <div>
          <SocialIcon
            network="twitter"
            url="https://twitter.com/sathishK_gru"
            className="social-icon"
            bgColor="#cbd5e1"
          />
          <SocialIcon
            network="stackoverflow"
            url="https://stackoverflow.com/users/9406334/sathish-kumar-elangovan"
            className="social-icon"
            bgColor="#cbd5e1"
          />
          <SocialIcon
            network="github"
            url="https://github.com/sathishk0230"
            className="social-icon"
            bgColor="#cbd5e1"
          />
          <SocialIcon
            network="linkedin"
            url="https://www.linkedin.com/in/sathish-kumar-e-1a5379168/"
            className="social-icon"
            bgColor="#cbd5e1"
          />
          <SocialIcon
            network="email"
            onClick={copyEmail}
            onTouchStart={copyEmail}
            className="social-icon"
            bgColor="#cbd5e1"
          />
          <span style={{ opacity: email }} className="tooltip">
            Email copied to clipboard!
          </span>
        </div>
      </div>
    </div>
  );
}

export default App;
